module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"notConnected":"Похоже, что ваша камера не подключена. Пожалуйста подключите камеру."}}')
  delete Component.options._Ctor
}
